import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { TechnologiesDescriptionDto } from "../../types/dto";
import { technologyQueryKeys } from "../queryKeyFactory";

type Options<T = TechnologiesDescriptionDto> = {
    select?: (data: TechnologiesDescriptionDto) => T;
    enabled?: boolean;
};

export const createDescriptionQuery = <T = TechnologiesDescriptionDto>({ select, enabled }: Options<T> = {}) =>
    queryOptions<TechnologiesDescriptionDto, Error, T>({
        enabled,
        queryKey: technologyQueryKeys.description(),
        staleTime: Number.POSITIVE_INFINITY,
        placeholderData: keepPreviousData,
        queryFn: ({ signal }) => salesApiService.technology.fetchDescription({ cancellation: signal }),
        select,
    });
